import { render, staticRenderFns } from "./Shopping.vue?vue&type=template&id=38c7036e"
import script from "./Shopping.vue?vue&type=script&lang=ts"
export * from "./Shopping.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports